import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum ApplicantsLandingPageFields {
    PRIVATE_NAME = 'privateName',
    INTRO = 'intro',
    STEPS = 'steps',
    IS_DEFAULT = 'isDefault',
    MS_BOOKING_LINK = 'msBookingLink',

    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ApplicantsLandingPageFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ApplicantsLandingPageFields, Data> = {
        [ApplicantsLandingPageFields.PRIVATE_NAME]: {
            text: 'Interne Bezeichnung',
        },
        [ApplicantsLandingPageFields.INTRO]: {
            text: 'Einleitungstext',
        },
        [ApplicantsLandingPageFields.STEPS]: {
            text: 'Zwischenschritte',
        },
        [ApplicantsLandingPageFields.IS_DEFAULT]: {
            text: 'Standardseite',
        },
        [ApplicantsLandingPageFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
        },
        [ApplicantsLandingPageFields.MS_BOOKING_LINK]: {
            text: 'Microsoft Booking Link',
        },
        [ApplicantsLandingPageFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
        },
    }

    export const Items = mapRecordToItems(Record);
}
